<template>
  <!-- GIF video card -->
  <el-card class="clip-card box-card">
    <!-- Card header (status, delete) -->
    <div slot="header" class="videoHeader">
      <div class="header-item">
        <el-button
          v-if="info.status == 'ready'"
          type="success"
          title="Download GIF"
          size="mini"
          class="videoItemButton"
          @click="downloadGIF"
        >
          <download title="Download GIF" class="videoItemIcon" />
        </el-button>
      </div>

      <div class="header-item">
        <el-tag
          v-if="info.status == 'generating'"
          effect="dark"
          style="cursor: help;"
          title="Conversion in progress"
          loading
          type="info"
        >
          <span style="color: white;">Generating</span>
        </el-tag>

        <el-tag
          v-if="info.status == 'failed'"
          effect="dark"
          style="cursor: help;"
          title="Conversion Failed"
          type="warning"
        >
          <span style="color: white;">Failed</span>
        </el-tag>

        <el-tag
          v-if="info.status == 'ready'"
          effect="dark"
          style="cursor: help;"
          title="Conversion Ready"
          type="success"
        >
          <span style="color: white;">Ready</span>
        </el-tag>
      </div>

      <div class="header-item">
        <el-button
          type="danger"
          title="Delete GIF"
          size="mini"
          class="videoItemButton"
          @click="removeGIFConfirmation"
        >
          <close-thick title="Delete Video" class="videoItemIcon" />
        </el-button>
      </div>
    </div>

    <!-- GIF image container -->
    <el-row>
      <el-col
        :xl="{ span: 24, offset: 0 }"
        :lg="{ span: 24, offset: 0 }"
        :md="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }"
        :xs="{ span: 24, offset: 0 }"
      >
        <div
          class="videoThumbContainer"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <img
            class="videoThumb videoThumb--active"
            :src="link"
            alt="GIF image"
          />
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
/* rest of imports */
import fallbackImage from "@/assets/images/empty.jpg";
import { mapState } from "vuex";
/** icons */
import Download from "vue-material-design-icons/Download.vue";
import CloseThick from "vue-material-design-icons/CloseThick.vue";

// @group Media/Video
// GIF card
export default {
  name: "GifItem",
  components: {
    /** icons */
    Download,
    CloseThick
  },
  props: {
    // GIF data
    info: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      thumbs: state => state.services.thumbs,
      app: state => state.services.app,
      stream: state => state.services.stream
    }),
    // @vuese
    // Link to GIF-file or failback image
    link() {
      return this.info.link
        ? this.info.link
        : fallbackImage;
    }
  },
  methods: {
    // @vuese
    // Show remove GIF confirmation
    removeGIFConfirmation() {
      this.$emit("remove");
    },
    // @vuese
    // Open new tab with GIF-file
    async downloadGIF() {
      this.$emit("download");
    }
  }
};
</script>

<style scoped>
.videoHeader {
  display: flex;
  justify-content: space-between;
  text-align: center;

  padding: 0.5em;
}
.header-item {
  width: 100px;
  flex-grow: 1;
}
.header-item:first-child {
  display: flex;
  justify-content: flex-start;
}
.header-item:last-child {
  display: flex;
  justify-content: flex-end;
}

.box-card {
  width: 100%;
  margin-bottom: 15px;
  overflow: hidden;
  background-color: #aaaaaa;
  justify-self: center;
}

.el-card__header {
  padding: 10px !important;
}

.el-card__body {
  padding: 10px !important;
}
.videoThumbContainer {
  position: relative;
}
.videoThumb {
  width: 100%;
  height: 100%;
  position: relative;
}
.videoThumb--active {
  cursor: pointer;
}
.videoHeaderContent {
  width: 100%;
  display: block;
  padding: 10px;
}
.actionGroup {
  display: flex;
  justify-content: flex-end;
  vertical-align: middle;
}

@media only screen and (max-width: 767px) {
  .videoHeaderContent {
    width: 100%;
    display: block;
    padding: 3px;
  }
  /** buttons */
  .videoItemButton {
    width: 1.5rem !important;
    height: 1.5rem !important;
    padding: 5px 3px;
  }
  .videoItemIcon {
    height: 10px !important;
    width: 10px !important;
  }
  .material-design-icon {
    padding-left: 1px;
    height: 0.7rem !important;
    width: 0.7rem !important;
    margin-top: 1px !important;
  }

  .material-design-icon__svg {
    padding-left: 1px;
    height: 0.7rem !important;
    width: 0.7rem !important;
    margin-top: 1px !important;
  }
}

@media only screen and (min-width: 768px) {
  .videoHeaderContent {
    width: 100%;
    display: block;
    padding: 3px;
  }
  /** buttons */
  .videoItemButton {
    width: 1.5rem !important;
    height: 1.5rem !important;
    padding: 5px 3px;
  }
  .videoItemIcon {
    height: 10px !important;
    width: 10px !important;
  }
  .material-design-icon {
    padding-left: 1px;
    height: 0.7rem !important;
    width: 0.7rem !important;
    margin-top: 1px !important;
  }

  .material-design-icon__svg {
    padding-left: 1px;
    height: 0.7rem !important;
    width: 0.7rem !important;
    margin-top: 1px !important;
  }
}

@media only screen and (min-width: 992px) {
  .videoHeaderContent {
    width: 100%;
    display: block;
    padding: 3px;
  }
  /** buttons */
  .videoItemButton {
    width: 1.5rem !important;
    height: 1.5rem !important;
    padding: 5px 3px;
  }
  .videoItemIcon {
    height: 10px !important;
    width: 10px !important;
  }
  .material-design-icon {
    padding-left: 1px;
    height: 0.7rem !important;
    width: 0.7rem !important;
    margin-top: 1px !important;
  }

  .material-design-icon__svg {
    padding-left: 1px;
    height: 0.7rem !important;
    width: 0.7rem !important;
    margin-top: 1px !important;
  }
}

@media only screen and (min-width: 1200px) {
  /** buttons */
  .videoItemButton {
    width: 2rem !important;
    height: 2rem !important;
    padding: 5px 3px;
  }
  .videoItemIcon {
    height: 10px !important;
    width: 10px !important;
  }
  .material-design-icon {
    padding-left: 1px;
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }

  .material-design-icon__svg {
    padding-left: 1px;
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}

@media only screen and (min-width: 1920px) {
  .videoHeaderContent {
    width: 100%;
    display: block;
    padding: 10px;
  }
  /** buttons */
  .videoItemButton {
    width: 2.2rem !important;
    height: 2.2rem !important;
    padding: 5px 3px;
  }
  .videoItemIcon {
    height: 10px !important;
    width: 10px !important;
  }
  .material-design-icon {
    padding-left: 1px;
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }

  .material-design-icon__svg {
    padding-left: 1px;
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}

.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

<style>
/** Styles for to fix size of GIFs with different ratios */
.gif-container .el-card__body {
  height: 200px;
}
.gif-container .el-card__body .el-row {
  margin-bottom: 0;
  padding-bottom: 20px;
}
.gif-container .el-card__body .el-row,
.gif-container .el-card__body .el-row .el-col,
.gif-container .videoThumbContainer {
  height: 100%;
}
.gif-container .videoThumb {
  object-fit: contain;
}
</style>
